// Single source of truth for the head-teacher school records CSV export
// (`GET /api/school/export/csv`). The server uses `name` to build the
// header row; the frontend disclosure dialog on the School Setup page
// uses `name` + `desc` to tell the head teacher exactly what they will
// receive. Order matters — the CSV columns are emitted in this order.
//
// Privacy posture: this list intentionally OMITS record body content
// (description, shorthandNotes, fields). See `live-visibility-guards.test.ts`
// and Task #86 for the full rationale.
export interface SchoolRecordsCsvColumn {
  name: string;
  desc: string;
}

export const SCHOOL_RECORDS_CSV_COLUMNS: readonly SchoolRecordsCsvColumn[] = [
  { name: "Date", desc: "When the record was logged" },
  { name: "Teacher", desc: "Authoring teacher's name" },
  { name: "Type", desc: "NCCD, Contact, Behaviour, or General" },
  { name: "Status", desc: "Open / closed / follow-up state" },
  { name: "Subject", desc: "Subject tag, if set" },
  { name: "Location", desc: "Location tag, if set" },
  { name: "Period", desc: "Period tag, if set" },
  { name: "Students", desc: "Names of linked students" },
  { name: "Entered in System", desc: "Yes / No — uploaded to school system" },
] as const;

export const SCHOOL_RECORDS_CSV_HEADER_NAMES: readonly string[] =
  SCHOOL_RECORDS_CSV_COLUMNS.map((c) => c.name);
